import { LinkedRecordConfig, MenuType } from "@/components/Table/types";

export type MarketOption = { value: string; label: string };

// Status options (colors match theme color names)
export const SHIFT_STATUS_OPTIONS = [
  { value: "PENDING", color: "pending" },
  { value: "APPROVED", color: "complete" },
  { value: "ADVANCED", color: "complete" },
  { value: "CANCELED", color: "attention" },
  { value: "CANCELED - BILLABLE", color: "neutral" },
  { value: "COMPLETE", color: "todo" },
] as const;

type FilterChoice = {
  name: string;
  kind: "text" | "number" | "boolean" | "date" | "decimal" | "enum" | "linked_record" | "array";
  menus?: MenuType[];
  displayName?: string;
  options?: { value: string; color?: string }[] | { value: string; label: string }[];
  linkedRecord?: LinkedRecordConfig;
};

export const getShiftKanbanConfig = (marketOptions: MarketOption[] = [], displayNames) => ({
  headerFunc: (name: string) => {
    switch (name) {
      case "client":
        return displayNames?.clients?.name ?? "Client";
      case "project":
        return displayNames?.projects?.name ?? "Project";
      case "location":
        return displayNames?.locations?.name ?? "Location";
      default:
        return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    }
  },
  filterChoices: [
    // Visible-only fields (card display control)
    { name: "name", kind: "text", displayName: "Name", menus: ["visible"] },
    { name: "progress", kind: "text", displayName: "Progress", menus: ["visible"] },
    { name: "positions", kind: "text", displayName: "Positions", menus: ["visible"] },

    // Filter + visible fields
    {
      name: "project",
      kind: "linked_record",
      displayName: `${displayNames?.projects?.name ?? "Project"}`,
      menus: ["filter", "visible"],
      linkedRecord: { labelKey: "name", valueKey: "id", truncate: 6 },
    },
    {
      name: "client",
      kind: "linked_record",
      displayName: `${displayNames?.clients?.name ?? "Client"}`,
      menus: ["filter", "visible"],
      linkedRecord: { labelKey: "name", valueKey: "id", truncate: 6 },
    },
    {
      name: "location",
      kind: "linked_record",
      displayName: "Location",
      menus: ["filter", "visible"],
      linkedRecord: { labelKey: "name", valueKey: "id", truncate: 6 },
    },
    { name: "markets", kind: "array" as const, displayName: "Markets", menus: ["filter"], options: marketOptions },

    // Time fields
    { name: "start_time", kind: "date", displayName: "Start Time", menus: ["filter"] },
    { name: "duration", kind: "number", displayName: "Duration (hrs)", menus: ["filter"] },

    // Status
    {
      name: "status",
      kind: "enum",
      displayName: "Status",
      menus: ["filter", "visible"],
      options: [...SHIFT_STATUS_OPTIONS],
    },
  ] as FilterChoice[],
});
